import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { patientDuring } from "@/mocks/patientInfo";

export default function PatientDuring() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Çekim sırasında"
            title="Merkezde sizi neler bekliyor?"
            description="Kayıttan kontrole kadar tüm süreç sade ve hızlıdır. Çekim ağrısız, tamamen dijital ve düşük dozlu bir işlemdir."
          />
        </Reveal>

        <div className="relative mt-16">
          <div
            className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-accent-400/50 to-transparent lg:block"
            aria-hidden="true"
          />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {patientDuring.map((step, index) => (
              <Reveal key={step.step} delay={index * 90}>
                <div className="relative">
                  <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-accent-300 bg-background-50 font-heading text-lg font-medium text-primary-700 ring-4 ring-background-50">
                    {step.step}
                  </span>
                  <h3 className="mt-6 font-heading text-lg font-medium tracking-tight text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}